import { render, staticRenderFns } from "./or_kj_report.vue?vue&type=template&id=308223d2&scoped=true"
import script from "./or_kj_report.vue?vue&type=script&lang=js"
export * from "./or_kj_report.vue?vue&type=script&lang=js"
import style0 from "./or_kj_report.vue?vue&type=style&index=0&id=308223d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308223d2",
  null
  
)

export default component.exports